import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Commission — owner-only. Har endpoint ke aage server par requireOwner laga
// hai (routes/admin/commissionConfigRoutes.js), staff/executive ko 403.
// Flow: commission-flow.md (repo root).
const commissionConfigService = {
  // Poora grid: { markets, sports: [{ sport_id, name, enabled, leagues: [{ key, label, is_default, rules, active_count }] }] }
  getSportsCommission: async () => {
    const response = await api.get(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS)
    return response.data
  },
  // { sport_id, league_key, market_key, enabled, percent }
  saveSportsCommission: async (payload) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, payload)
    return response.data
  },
  // items: [{ sport_id, league_key, market_key, enabled, percent }, …] — saare dirty cells ek call me
  saveSportsCommissionBulk: async (items) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS_BULK, { items })
    return response.data
  },
  // { sport_id, league_key, market_key } — variant league ka cell wapas Inherit (row delete)
  resetSportsCommission: async (payload) => {
    const response = await api.delete(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, { data: payload })
    return response.data
  },
}

export default commissionConfigService
